export default __webpack_public_path__ + "static/media/GR00044-cre_bill.8bf29659.svg";